export const isDeployedToProduction = window.location.hostname === 'provider.quick.md'
